import { inject } from 'inversify-props';
import IAuthService from 'services/IAuthService';
import { FormatParameter } from '@models';
import { AxiosPromise } from 'axios';

class FormatParameterTypeService {
    @inject() private authService: IAuthService;

    host: string = `${window.location.protocol}//${window.location.host}`;
    api: string = '/api/formatparameter/';


    constructor(api: string = null) {
        if (api) this.api = api
    }

    getFormatParameters(formatVersionId: string): AxiosPromise<FormatParameter[]> {
        const endpoint = this.host + this.api + `all?formatVersionId=${formatVersionId}`;
        const response = this.authService.getV2(endpoint);
        return response;
    }

    createFormatParameters(parameters: FormatParameter[]): AxiosPromise<FormatParameter[]> {
        const endpoint = this.host + this.api;
        const response = this.authService.post(endpoint, parameters);
        return response;
    }


}

export default new FormatParameterTypeService();
